import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { MarkdownEditor } from '../../fields/markdown/MarkdownEditor';
import { valueOf } from '../../form/valueOf';
import type { IArticleTabProps } from './IArticleTabProps';

/**
 * Вкладка «Редагувати» статті (прототип v4): редактор Markdown (панель форматування, «Писати · Розділений · Перегляд»); відкриття вкладки
 * вмикає режим редагування запису, зміни зберігає «Зберегти · N» панелі дій.
 */
export function ArticleEditTab({ ws, rt, record, editor }: IArticleTabProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const canEdit = record.permissions?.edit !== false;
  const started = useRef(false);
  const { startEdit } = editor;
  useEffect(() => { if (!started.current && canEdit) { started.current = true; startEdit(); } }, [canEdit, startEdit]);
  const field = rt.fields.find((f) => f.key === 'body');
  return (
    <MarkdownEditor id="rec-article" value={String(valueOf(record, editor.draft, 'body') ?? '')} onChange={(v) => editor.setField('body', v)} ws={ws}
      label={field ? strings.field(rt.key, 'body', field.label) : t('recordPage.tabs.edit')} readOnly={!canEdit} />
  );
}
